<template>
  <span class="inline-flex">
    <ButtonSecondary
      dusk="search-invite-button"
      title="Invite Link"
      aria-label="Invite Link"
      @click="open = true; loadLinks()"
    >
      <EnvelopeIcon class="h-5 border-0 mr-1.5"/>
      Invite Link
    </ButtonSecondary>

    <SimpleModal
      :open="open"
      @cancel="open = false"
      cancelText="Close"
      :hideConfirm="true"
      :title="'Invite Links — ' + searchName"
    >
      <div class="mt-2">

        <p class="text-sm text-gray-500 mb-4">
          Invite links are valid for 30 days. Recipients see the position details and can register for an account.
        </p>

        <div v-if="loading" class="text-sm text-gray-400 py-4 text-center">Loading...</div>

        <div v-else-if="links.length > 0" class="mb-6">
          <label class="block text-sm font-medium text-gray-700 mb-2">Active Invite Links</label>
          <ul class="space-y-3">
            <li
              v-for="link in links"
              :key="link.id"
              class="rounded-lg border border-gray-200 bg-gray-50 px-4 py-3"
            >
              <div class="flex items-center justify-between gap-2">
                <div class="flex-1 min-w-0">
                  <div class="flex items-center gap-2 mt-1 relative">
                    <input
                      type="text"
                      :value="link.url"
                      readonly
                      class="shadow-sm block w-full sm:text-sm border-gray-300 rounded-md pr-10 text-gray-700 bg-white"
                    >
                    <button
                      class="absolute right-1 top-1 border p-1 bg-white hover:bg-gray-100 rounded-md"
                      @click="copyUrl(link.url)"
                      title="Copy link"
                    >
                      <ClipboardDocumentIcon class="h-5 border-0"/>
                    </button>
                  </div>
                  <p class="text-xs text-gray-400 mt-1">Expires in {{ link.time_remaining }}</p>
                </div>
              </div>
            </li>
          </ul>
        </div>

        <div v-else class="mb-4 text-sm text-gray-500 py-3 text-center border border-dashed border-gray-200 rounded-lg">
          No active invite links yet.
        </div>

        <div v-if="newLink" class="mb-4 rounded-lg border border-indigo-200 bg-indigo-50 px-4 py-3">
          <p class="text-sm font-medium text-indigo-800 mb-2">New link created &mdash; expires in {{ newLink.time_remaining }}</p>
          <div class="flex items-center gap-2 relative">
            <input
              type="text"
              :value="newLink.url"
              dusk="new-invite-url"
              readonly
              class="shadow-sm block w-full sm:text-sm border-indigo-300 rounded-md pr-10 text-gray-700 bg-white"
            >
            <button
              class="absolute right-1 top-1 border p-1 bg-white hover:bg-gray-100 rounded-md"
              @click="copyUrl(newLink.url)"
              title="Copy link"
              dusk="copy-invite-url"
            >
              <ClipboardDocumentIcon class="h-5 border-0"/>
            </button>
          </div>
        </div>

        <button
          dusk="create-invite-link"
          class="w-full mt-2 flex items-center justify-center gap-2 px-4 py-2.5 border border-indigo-300 text-indigo-700 bg-white hover:bg-indigo-50 text-sm font-medium rounded-lg transition-colors"
          :disabled="creating"
          @click="createLink"
        >
          <PlusIcon class="h-4 w-4"/>
          {{ creating ? 'Creating...' : 'Create New 30-Day Link' }}
        </button>

      </div>
    </SimpleModal>
  </span>
</template>

<script>
import ButtonSecondary from "./ButtonSecondary.vue";
import SimpleModal from "./SimpleModal.vue";
import axios from 'axios';
import { EnvelopeIcon, ClipboardDocumentIcon, PlusIcon } from '@heroicons/vue/24/solid';

export default {
  name: "SearchInviteButton",
  components: {
    ButtonSecondary,
    SimpleModal,
    EnvelopeIcon,
    ClipboardDocumentIcon,
    PlusIcon,
  },
  data() {
    return {
      open: false,
      loading: false,
      creating: false,
      links: [],
      newLink: null,
    };
  },
  props: {
    searchName: {
      type: String,
      required: true,
    },
    indexUrl: {
      type: String,
      required: true,
    },
    storeUrl: {
      type: String,
      required: true,
    },
  },
  methods: {
    async loadLinks() {
      this.loading = true;
      try {
        const { data } = await axios.get(this.indexUrl);
        this.links = data;
      } finally {
        this.loading = false;
      }
    },

    async createLink() {
      this.creating = true;
      try {
        const { data } = await axios.post(this.storeUrl);
        this.newLink = data;
      } finally {
        this.creating = false;
      }
    },

    copyUrl(url) {
      navigator.clipboard.writeText(url);
    },
  },
};
</script>
